import { MarkHearthArch as HearthMark } from "./brand/Marks";
import { SITE } from "../lib/site";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Seo } from "./Seo";

export const LEGAL = {
  product: "HearthVault",
  contactEmail: SITE.contactEmail,
  contactPath: SITE.contactPath,
  effective: "September 21, 2026",
};

export const LegalLayout = ({ title, intro, children, testId, path }) => (
  <div className="min-h-screen bg-background text-foreground" data-testid={testId}>
    <Seo title={title} description={intro} path={path || `/${(testId || "").replace("-page", "")}`} />
    <header className="border-b border-border">
      <div className="max-w-3xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 font-serif text-lg" data-testid="legal-home-link"><span className="grid place-items-center h-8 w-8 rounded-lg bg-primary text-primary-foreground"><HearthMark className="h-4 w-4" /></span> {LEGAL.product}</Link>
        <nav className="flex gap-5 text-xs text-muted-foreground">
          <Link to="/privacy" className="hover:text-foreground" data-testid="legal-nav-privacy">Privacy</Link>
          <Link to="/terms" className="hover:text-foreground" data-testid="legal-nav-terms">Terms</Link>
        </nav>
      </div>
    </header>
    <main className="max-w-3xl mx-auto px-6 py-14">
      <Link to="/" className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground"><ArrowLeft className="h-3 w-3" /> Back to home</Link>
      <h1 className="mt-4 font-serif text-4xl sm:text-5xl tracking-tight" data-testid="legal-title">{title}</h1>
      <p className="mt-2 text-xs font-mono uppercase tracking-widest text-muted-foreground">Effective {LEGAL.effective}</p>
      {intro && <p className="mt-6 text-base text-muted-foreground leading-relaxed">{intro}</p>}
      <div className="mt-10 space-y-10">{children}</div>
      <p className="mt-16 text-xs text-muted-foreground border-t border-border pt-6">Questions? <Link to={LEGAL.contactPath} className="text-primary hover:underline" data-testid="legal-contact-link">Open a support request</Link> — we answer every ticket, usually within a business day.</p>
    </main>
  </div>
);

export const Section = ({ id, title, children }) => (
  <section id={id} data-testid={`legal-section-${id}`}>
    <h2 className="font-serif text-2xl tracking-tight">{title}</h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-foreground/90 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1.5 [&_strong]:font-semibold">{children}</div>
  </section>
);
